import React from 'react'
import Layout from '../components/Layout'
import StaffProfileTemplate from '../components/StaffProfiles'

const Component = () => {
  return (
    <Layout>
      <StaffProfileTemplate
        heroClass="is-hidden-touch"
      />
    </Layout>
  )
}

Component.propTypes = {}

export default Component